import React from 'react';
import { DpCheckbox } from '@/components/blocks/DpCheckbox';
import { CheckboxProps } from '@mui/material';

export const BpCheckbox = (props: CheckboxProps) => (
	<DpCheckbox
		sx={{
			'&:hover': { bgcolor: 'transparent' },
			px: '9px',
			py: '0px',
		}}
		disableRipple
		color="default"
		inputProps={{ 'aria-label': 'Checkbox demo' }}
		{...props}
	/>
);
